// Lets the header menu, admin nav and profile dropdown close each other so they never overlap.
const CLOSE_MENUS = 'qercha:close-menus';

// Asks every other menu to close; `source` names the menu that is opening so it ignores its own event
export const closeOtherMenus = (source) => window.dispatchEvent(new CustomEvent(CLOSE_MENUS, { detail: source }));

// Calls `handler` when a different menu asks to close. Returns the cleanup function for useEffect.
export const onCloseMenus = (source, handler) => {
  const listener = (e) => { if (e.detail !== source) handler(); };
  window.addEventListener(CLOSE_MENUS, listener);
  return () => window.removeEventListener(CLOSE_MENUS, listener);
};
